import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getImageSpec } from '@/utils/locals';
import { createEFPic } from '@/utils/useEFPic';
const { EFPic } = createEFPic('/media/smarthomepanel/pc/');

export default function Comp() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('smarthomepanel');
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['uk', 'au', 'jp', 'de', 'fr', 'es', 'it', 'eu', 'za']);

    return (
        <div className={`${css.aniFGsapB1} aniFGsapB1`}>
            <div className="anif-img-box">
                <EFPic
                    name={[`img_17_new_${imgSpec}.webp`, `img_17_new_${imgSpec}.jpg`]}
                    // layout="fill"
                    className="fullImgs"
                    alt={t('Modular Design')}
                    // noUseSrcset={true}
                />
            </div>
            <div className="anif-items-box">
                <div className="item-l">
                    <div className="msg-l-1">{t('smart_home_panel.thirteen_des')} </div>
                    <div className="img-l-1">
                        <div className="img-t-1">
                            <div className="img-t-1-in img-t-1-in1">
                                <EFPic
                                    name={["img_16_new1.webp", "img_16_new1.png"]}
                                    // layout="fill"
                                    className="fullImgs"
                                    alt={t('Modular Design')}
                                    // noUseSrcset={true}
                                />
                            </div>
                            <div className="img-t-1-in img-t-1-in2">
                                <EFPic
                                    name={["img_16_new2.webp", "img_16_new2.png"]}
                                    // layout="fill"
                                    className="fullImgs"
                                    alt={t('Modular Design')}
                                    // noUseSrcset={true}
                                />
                            </div>
                        </div>
                        <div className="img-t-2">
                            <EFPic
                                name={["img_15.webp", "img_15.png"]}
                                // layout="fill"
                                className="fullImgs"
                                alt={t('Modular Design')}
                                // noUseSrcset={true}
                            />
                        </div>
                    </div>
                </div>
                <div className="item-r">
                    <div className="msg-r-1">{t('smart_home_panel.fourteen_title')}</div>
                    <div className="msg-r-2">{t('smart_home_panel.fourteen_subtitle')}</div>
                    <div className="msg-r-3">{t('smart_home_panel.fourteen_des')}</div>
                </div>
            </div>
        </div>
    );
}
